//just a check
const About = () => (
    <div className="about-section">
        <div className="about-section-container">
        <h1>This is the about section</h1>
        <p>Hello and welcome</p>
        <p><i>"The weather wise application was designed to give the user the information in a fast and affective way about how the weather would impact their day perticipating in their choosen sport. It achieves this with taking into account the weather factors that will affect the specified sport, which has been selected by the user. Then it will run an algorithem that will check the parameters of the weather and produce an easy to understand rating system. This project is a student project, for the Wild Code School, which is a 5 month bootcamp in web development, it is carried out while learning React."</i></p>
        </div>
    </div>
)

export default About;